import RadioControl, {
  Props as BaseRadioControlProps,
} from '@/components/Controls/RadioControl';

import { useDemoContext } from './DemoContext';

type RadioControlProps = Omit<
  BaseRadioControlProps,
  'value' | 'setValue'
>;

function DemoRadioControl({ id, ...props }: RadioControlProps) {
  const context = useDemoContext();

  const { id: demoUnitId, state, setState } = context;
  const value = state[id];
  const htmlId = `${demoUnitId}_${id}`;

  return (
    <RadioControl
      {...props}
      id={htmlId}
      value={value}
      setValue={(newValue: any) => {
        setState((state) => ({
          ...state,
          [id]: newValue,
        }));
      }}
    />
  );
}

export default DemoRadioControl;
